import { LitElement, TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import { SlotControllerLegacy } from '../../controllers/slot-controller-legacy';
import innerCSS from './se-search-hero.inner.pcss?inline';
import '../se-search-panel/se-search-panel';
import '../se-container/se-container';
import '../se-heading/se-heading';

/**
 * The SeSearchHero component
 * @element se-search-hero
 * @slot - image: Image markup
 * @slot - search-panel: <se-search-panel> component
 */
@customElement('se-search-hero')
export class SeSearchHero extends LitElement {
  private stylesheetController = new AdoptedStyleSheets(this, {
    encapsulatedCSS: innerCSS,
  });
  slots = new SlotControllerLegacy(
    this, // This, the host element.
    true // To shift or not to shift LightDom nodes to ShadowDOM.
  );

  /**
   * Hero title
   */
  @property({ type: String })
  heading: string;

  /**
   * Hero body text
   */
  @property({ type: String })
  description: string;

  render(): TemplateResult {
    return html`
      <section class="se-search-hero">
        <div class="se-search-hero--image">
          <slot name="image"></slot>
        </div>
        <se-container>
          <div class="se-search-hero--card">
            <se-heading level="h1">${this.heading}</se-heading>
            <p class="se-search-hero--description">${this.description}</p>
          </div>
        </se-container>
      </section>
    `;
  }
}
